import { SelectOption } from "components/atoms/Select";
import { dynamicState } from ".";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { config } from "config";

const initialState: dynamicState = {
  dynamics: [],
  dynamicBanner: null,
  jeenyBanner: null,
  videoMedia: null,
  countryPrices: [],
  tanfeethi: [],
  al_masar: [],
  dynamicCarMovements: [],
  movementTypeOptions: [],
  platformTypeOptions: [],
  dynamicSelections: [],
  dynamicSelectionsOptions: [],
  loading: true,
  contentfulCache: [],
  aggregatorMarkups: [],
};

export const dynamicSlice = createSlice({
  name: "dynamic",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setdynamics: (state, action) => {
      state.dynamics = action.payload;
    },
    setdynamicBanner: (state, action) => {
      state.dynamicBanner = action.payload;
    },
    setVideo: (state, action) => {
      const video = action.payload;
      state.videoMedia = video;
    },
    setJeenyBanner: (state, action) => {
      state.jeenyBanner = action.payload;
    },
    setCountryPrices: (state, action) => {
      state.countryPrices = action.payload;
    },
    setTanfeethi: (state, action) => {
      state.tanfeethi = action.payload;
    },
    setAlMasar: (state, action) => {
      state.al_masar = action.payload;
    },
    setDynamicCarMovement: (state, action) => {
      const { data, type } = action.payload;
      state.dynamicCarMovements = data;
      if (type === "movementType") {
        let options: SelectOption[] = [];
        data.forEach(({ _id, name, is_active }: any) => {
          if (is_active) {
            const option = { value: _id, label: `${name}` };
            options.push(option);
          }
        });
        state.movementTypeOptions = options;
      }
      if (type === "platformType") {
        let options: SelectOption[] = [];
        data.forEach(({ _id, name, is_active }: any) => {
          if (is_active) {
            const option = { value: _id, label: `${name}` };
            options.push(option);
          }
        });
        state.platformTypeOptions = options;
      }
    },
    setDynamicSelection: (state, action) => {
      const { data, type } = action.payload;
      state.dynamicSelections = data;

      let options: SelectOption[] = [];
      data.forEach(({ _id, name, is_active }: any) => {
        if (is_active) {
          const option = { value: _id, label: `${name}` };
          options.push(option);
        }
      });
      state.dynamicSelectionsOptions = options;

    },
    setContentfulCache: (state, action) => {
      state.contentfulCache = action.payload || [];
    },
    setAggregatorMarkups: (state, action) => {
      state.aggregatorMarkups = action.payload || [];
    },
  
  },
});

export const dynamicReducer = dynamicSlice.reducer;

export const dynamicActions = dynamicSlice.actions;
